import Cookies from "js-cookie";

export const getHeaderKeys = (headerKeys) => {
  const res = {};
  headerKeys.forEach((key) => {
    if (Cookies.get(key)) {
      res[key] = Cookies.get(key);
    }
  });
  return Object.keys(res).length > 0 ? res : "";
};
